import React from 'react';
import Badge from '../ui/Badge';

export default function WorkspaceKpis({ items = [], activeKpi, onSelect }) {
  return (
    <div className="sp-kpi-grid" role="tablist" aria-label="Workspace KPIs">
      {items.map((item) => {
        const isActive = activeKpi === item.id;
        const value = item.value ?? 0;
        return (
          <button
            key={item.id}
            type="button"
            className={`sp-kpi-card ${isActive ? 'sp-kpi-card--active' : ''}`}
            onClick={() => onSelect?.(item.id)}
            aria-pressed={isActive}
          >
            <div className="sp-kpi-label">{item.label}</div>
            <div className="sp-kpi-value">{value}{item.suffix || ''}</div>
            {item.badge && value > 0 && <Badge variant={item.badge.variant}>{item.badge.label}</Badge>}
          </button>
        );
      })}
    </div>
  );
}
